import { useTheme } from '@fluentui/react/lib/Theme';
import { IPLink, IPSpinner, IPSpinnerSize, IPText } from 'baseComponents';
import { IPStack } from 'baseComponents/Stack/IPStack';
import AISuggestionMessage from 'components/Notification/AISuggestionMessage';
import { globalStackTokensGapExtraSmall, globalStackTokensGapSmall } from 'globalStyles';
import { useTranslation } from 'react-i18next';

// Presentational parts of the wizard AI actions; the state lives in useNewTaskWizardAI.

//the slim line at the top of the result area while an AI action runs
export const WizardAIWorking = () => {
  const { t } = useTranslation(['task']);
  const theme = useTheme();

  return (
    <IPStack horizontal verticalAlign="center" tokens={globalStackTokensGapSmall}>
      <IPStack.Item>
        <IPSpinner size={IPSpinnerSize.small} />
      </IPStack.Item>
      <IPStack.Item>
        <IPText variant="small" styles={{ root: { color: theme.semanticColors.bodySubtext } }}>
          {t('task:NewTaskWizard.AI.Working')}
        </IPText>
      </IPStack.Item>
    </IPStack>
  );
};

interface IWizardAIResultBarProps {
  lines: string[];
  onUndo: () => void;
  onDismiss: () => void;
}

//what the AI changed, with Undo
export const WizardAIResultBar = (props: IWizardAIResultBarProps) => {
  const { t } = useTranslation(['task']);

  return (
    <AISuggestionMessage onDismiss={props.onDismiss}>
      <IPStack tokens={globalStackTokensGapExtraSmall}>
        {props.lines.map((line) => (
          <IPText key={line} block>
            {line}
          </IPText>
        ))}
        <IPStack.Item>
          <IPLink onClick={props.onUndo}>{t('task:NewTaskWizard.AI.Undo')}</IPLink>
        </IPStack.Item>
      </IPStack>
    </AISuggestionMessage>
  );
};
